import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "list__title" }
const _hoisted_2 = {
  key: 0,
  class: "list__buttons"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "profile__run" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Panel = _resolveComponent("Panel")!
  const _component_words_list = _resolveComponent("words-list")!
  const _component_account_word = _resolveComponent("account-word")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "listWords",
    class: "list__info",
    onMousedown: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
    onContextmenu: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.setOpenPanel($event, _ctx.index)), ["prevent"])),
    onClick: [
      _cache[12] || (_cache[12] = _withModifiers(() => {}, ["ctrl","stop"])),
      _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.runWords(_ctx.wordsArray.title)), ["exact"]))
    ]
  }, [
    (!_ctx.editMode && _ctx.isOpenPanel == _ctx.index)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "panel",
          class: "list__panel",
          onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"])),
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"]))
        }, [
          _createVNode(_component_Panel, {
            words: _ctx.wordsArray.words,
            userID: _ctx.$route.params.id,
            title: _ctx.wordsArray.title,
            onOpenModal: _ctx.openModal,
            onEditWords: _ctx.editWords,
            onSetOpenPanel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpenPanel($event, -1)))
          }, null, 8, ["words", "userID", "title", "onOpenModal", "onEditWords"])
        ], 544))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.wordsArray.title), 1),
      (_ctx.isMyUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.editMode)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "profile__run",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteWords(_ctx.wordsArray.title)))
                }, _toDisplayString(_ctx.Ti18N("account.wordsTable.panel.delete")), 1))
              : _createCommentVNode("", true),
            (_ctx.editMode != _ctx.wordsArray.title)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "profile__run",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.editWords(_ctx.wordsArray.words, _ctx.wordsArray.title)), ["stop"]))
                }, _toDisplayString(_ctx.Ti18N("account.wordsTable.panel.change")), 1))
              : (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "profile__run",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.stopEdit && _ctx.stopEdit(...args)), ["stop"]))
                }, _toDisplayString(_ctx.Ti18N("account.wordsTable.panel.cancel")), 1))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isMyUser && _ctx.isAddedToMyDictionaryList != _ctx.index && _ctx.index != -1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            ref: "btnAddToList",
            onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveDictionary && _ctx.saveDictionary(...args)), ["stop"])),
            class: "profile__run"
          }, _toDisplayString(_ctx.Ti18N("account.wordsTable.panel.addToOwnDictionary")), 513))
        : (!_ctx.isMyUser && _ctx.isAddedToMyDictionaryList == _ctx.index)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.Ti18N("account.wordsTable.panel.successAdding")), 1))
          : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wordsArray.words, (words, index2) => {
      return (_openBlock(), _createElementBlock("div", {
        key: words,
        class: "list__words"
      }, [
        (_ctx.editMode != _ctx.wordsArray.title)
          ? (_openBlock(), _createBlock(_component_words_list, {
              key: 0,
              words: _ctx.wordsArray.words[index2],
              index: _ctx.index
            }, null, 8, ["words", "index"]))
          : (_openBlock(), _createBlock(_component_account_word, {
              key: 1,
              "word-data": _ctx.editList.value[index2],
              title: _ctx.wordsArray.title,
              index: index2,
              onSaveWord: _ctx.saveWord
            }, null, 8, ["word-data", "title", "index", "onSaveWord"]))
      ]))
    }), 128)),
    (_ctx.editMode == _ctx.wordsArray.title)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "list__footer",
          onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("button", {
            class: "profile__run",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveEditWords(_ctx.wordsArray.title, _ctx.wordsArray.id)))
          }, _toDisplayString(_ctx.Ti18N("account.wordsTable.panel.save")), 1),
          _createElementVNode("button", {
            class: "profile__run",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
          }, _toDisplayString(_ctx.Ti18N("account.wordsTable.panel.newWords")), 1),
          _createElementVNode("button", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: `/account/${_ctx.userID}/setupfolder?title=${_ctx.wordsArray.title}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Ti18N("account.wordsTable.panel.addToSection")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 544))
}